import React, { useEffect, useRef, useState } from "react";
import "./CompanyInfo.scss";
import Attachments from "../../components/Attachments/Attachments";
import Notifications from "../../components/Notifications/Notifications";
import { useForm } from "react-hook-form";
import { useStateValue } from "../../StateProvider";
import {
  addCompanyInfo,
  getCompanyInfo,
  signup,
  updateCompanyInfo,
} from "../../apiCall";
import { useQuery } from "@tanstack/react-query";
import { IoIosCloseCircle } from "react-icons/io";
import toast from "react-hot-toast";
import Attachment from "../Attachment/Attachment";
import { validateNoBlankSpaces } from "../../utils/formValidation";
const CompanyInfo = () => {
  const [tab, setTab] = useState("information");
  const [, dispatch] = useStateValue();
  const [logoImage, setlogoImage] = useState("");
  const [isCancel, setIsCancel] = useState(false);
  const imageRef = useRef();
  const [editStatus, setEditStatus] = useState(false);

  // **************************************************** company info start *****************************************************
  const queryKey = ["company-info"];
  const fetchCompanyInfo = async () => {
    // Perform the API call to fetch company info
    let response
    try {
      response = await getCompanyInfo();
      if (response?.status === 200) {
        setCompanyInfo(response.data);
      } else if (response?.response) {
        toast.error(response?.response?.data?.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
      throw error;
    }
    return response
  };

  const { data: companyData } = useQuery({
    queryKey,
    queryFn: fetchCompanyInfo,
    onSuccess: (Re) => {
      console.log(Re);
    },
    onError: (e) => {
      console.log(e);
    },
  });
  const [companyInfo, setCompanyInfo] = useState(
    companyData?.status === 200 ? companyData.data : {}
  );

  // **************************************************** company info start *****************************************************
  //******************************************attachment start **************************************************
  const [attachmentCount, setAttachmentCount] = useState(0);
  const [isAddAttachments, setIsAddAttachments] = useState(false);
  const [title, setTitle] = useState("Update Company");
  const formRef = useRef(null);


  const handleExternalSubmit = () => {
    if (tab === "information" && editStatus) {
      setIsAddAttachments(true);
      if (formRef.current) {
        setTimeout(() => {
          formRef.current.dispatchEvent(
            new Event("submit", { cancelable: true, bubbles: true })
          );
        }, 100);
      }
    } else {
      setTab("attachments");
      setTitle("Update Company");
      setIsAddAttachments(false);
    }
  };

  //******************************************attachment end **************************************************
  // **************************************************** form start *****************************************************
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({ defaultValues: {} });
  const watchField = watch()
  const onSubmit = async (data) => {
    dispatch({ type: "SET_LOADING", status: true });
    let re;
    data.AutoNotification = data?.AutoNotification ? data?.AutoNotification.toString() : "false"

    if (companyInfo?.Code) {
      re = await updateCompanyInfo(data);
    } else {
      re = await addCompanyInfo(data);
    }
    console.log(re);
    if (re?.status === 201 || re?.status === 200) {
      if (isAddAttachments) {
        setTab("attachments");
        setTitle("Update Company");
        setIsAddAttachments(false);
      } else {
        toast.success("success");
        setEditStatus(false);
      }
    } else if (re?.response) {
      toast.error(re?.response?.data?.message);
    }
    dispatch({ type: "SET_LOADING", status: false });
  };

  useEffect(() => {
    console.log(companyInfo);
    if (companyInfo) {
      setValue("Code", companyInfo?.Code);
      setValue("Name", companyInfo?.Name);
      setValue("Logo", companyInfo?.Logo);
      setlogoImage(companyInfo?.Logo);
      setValue("Mobile", companyInfo?.Mobile);
      setValue("EMail", companyInfo?.EMail);
      setValue("Addr1", companyInfo?.Addr1);
      setValue("Addr2", companyInfo?.Addr2);
      setValue("Area", companyInfo?.Area);
      setValue("City", companyInfo?.City);
      setValue("AutoNotification", companyInfo?.AutoNotification);
      setValue(
        "Country",
        companyInfo?.Country ? companyInfo?.Country : "India"
      );
      setValue("Pincode", companyInfo?.Pincode);
      setValue("WebAddr", companyInfo?.WebAddr);
      setAttachmentCount(companyInfo?.attachments_no);
    }
  }, [companyInfo, isCancel]);

  // **************************************************** form start end *****************************************************

  // **************************************************** image change fun start *****************************************************
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        // Once the file is read, set the Base64 string
        setValue("Logo", reader.result);
        setlogoImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };
  // **************************************************** image change fun end *****************************************************

  // **************************************************** remove image fun start *****************************************************

  const removeImage = () => {
    setlogoImage("");
    setValue("Logo", "");
  };
  // **************************************************** remove image fun end *****************************************************
  return (
    <div id="app-content">
      {/* Container fluid */}
      <div className="app-content-area mb-10">
        <div className="container-fluid ">
          <div className="mx-n6 mt-n6 pt-6 mb-6 header">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-12">
                {/* Page header */}
                <div
                  className="d-lg-flex
          align-items-center justify-content-between px-6"
                >
                  <div className="mb-6 mb-lg-0">
                    <div className="d-flex align-items-center">
                      <div className="">
                        <h1 className="mb-0 h3 ">{title} </h1>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  {/* nav  */}
                  <ul className="nav nav-lb-tab px-6">
                    <li className="nav-item ms-0 me-3">
                      <div
                        role="button"
                        className={`${tab === "information"
                          ? "nav-link active "
                          : "nav-link"
                          }`}
                        onClick={() => {
                          setTab("information");
                          setTitle("Update Company");
                        }}
                      >
                        Information
                      </div>
                    </li>
                    <li className="rounded-circl notification-count nav-item mx-3">
                      <div
                        role="button"
                        className={`${tab === "attachments"
                          ? "nav-link active "
                          : "nav-link"
                          }`}
                        onClick={() => {
                          handleExternalSubmit();
                        }}
                      >
                        Attachments
                      </div>
                      <div
                        className="notification-count d-flex justify-content-center"
                        style={{ top: "3px", right: "-14px" }}
                      >
                        {attachmentCount}
                      </div>
                    </li>
                    {/* <li className="nav-item mx-3">
                      <div
                        role="button"
                        className={`${
                          tab === "notifications"
                            ? "nav-link active "
                            : "nav-link"
                        }`}
                        onClick={() => setTab("notifications")}
                      >
                        Notifications
                      </div>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="row">
            <div className="col-lg-12 col-md-12 col-12">
              <div className="mb-5">
                <h3 className="mb-0 ">Add Staff</h3>
              </div>
            </div>
          </div> */}
          <div>
            {/* row */}
            <div className="row">
              <div className="col-xl-12 col-md-12 col-12">
                {/* card */}
                {(() => {
                  switch (tab) {
                    case "information":
                      return (
                        <form onSubmit={handleSubmit(onSubmit)} ref={formRef}>
                          <div className="card mb-5">
                            {/* card body */}
                            <div className="card-body" style={{ padding: "10px" }}>
                              {/* form */}
                              <div className="row">
                                {/* form group */}
                                <div className="mb-4 col-md-5 col-12">
                                  <label className="form-label">
                                    Code <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter code of company"
                                    disabled
                                    {...register("Code", {
                                      required: "Code is required",
                                      validate: validateNoBlankSpaces,
                                    })}
                                  />
                                  {errors.Code && (
                                    <div className="error">
                                      {errors.Code.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-7 col-12">
                                  <label className="form-label">
                                    Name <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    // disabled={!editStatus}
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter name of company"
                                    disabled
                                    {...register("Name", {
                                      required: "Name is required",
                                      validate: validateNoBlankSpaces,
                                    })}
                                  />
                                  {errors.Name && (
                                    <div className="error">
                                      {errors.Name.message}
                                    </div>
                                  )}
                                </div>

                                {/* form group */}
                                <div className="mb-4 col-md-5 col-12">
                                  <label className="form-label">
                                    Mobile{" "}
                                    {/* <span className="text-danger">*</span> */}
                                  </label>
                                  <input
                                    disabled={!editStatus}
                                    type="number"
                                    min="0"
                                    className="form-control"
                                    placeholder="Enter mobile"
                                    {...register(
                                      "Mobile",
                                      {
                                        pattern: {
                                          value: /^[0-9]{10}$/,
                                          message: "Invalid mobile number.",
                                        },
                                      }
                                      // , {
                                      //   required: "Mobile is required",
                                      // }
                                    )}
                                  />
                                  {errors.Mobile && (
                                    <div className="error">
                                      {errors.Mobile.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-7 col-12">
                                  <label className="form-label">
                                    Email
                                    {/* <span className="text-danger">*</span> */}
                                  </label>
                                  <input
                                    disabled={!editStatus}
                                    type="email"
                                    className="form-control"
                                    placeholder="Enter email"
                                    {...register(
                                      "EMail",
                                      {
                                        pattern: {
                                          value:
                                            /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                                          message: "Invalid email address.",
                                        },
                                      }
                                      // , {
                                      //   required: "EMail is required",
                                      // }
                                    )}
                                  />
                                  {errors.EMail && (
                                    <div className="error">
                                      {errors.EMail.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-7 col-12">
                                  <label className="form-label">
                                    Address{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    disabled={!editStatus}
                                    type="text"
                                    className="form-control mb-2 "
                                    placeholder="Address line 1"
                                    {...register("Addr1", {
                                      required: "Address line 1 is required",
                                      validate: validateNoBlankSpaces,
                                    })}
                                  />
                                  {errors.Addr1 && (
                                    <div className="error">
                                      {errors.Addr1.message}
                                    </div>
                                  )}
                                  <input
                                    disabled={!editStatus}
                                    type="text"
                                    className="form-control mb-2 "
                                    placeholder="Address line 2"
                                    {...register(
                                      "Addr2"
                                      // , {
                                      //   required: "Address line 2 is required",
                                      // }
                                    )}
                                  />
                                  {errors.Addr2 && (
                                    <div className="error">
                                      {errors.Addr2.message}
                                    </div>
                                  )}
                                  <input
                                    disabled={!editStatus}
                                    type="text"
                                    className="form-control mb-2 "
                                    placeholder="Area"
                                    {...register("Area", {
                                      required: "Area is required",
                                      validate: validateNoBlankSpaces,
                                    })}
                                  />
                                  {errors.Area && (
                                    <div className="error">
                                      {errors.Area.message}
                                    </div>
                                  )}
                                  <input
                                    disabled={!editStatus}
                                    type="text"
                                    className="form-control mb-2 "
                                    placeholder="City"
                                    {...register("City", {
                                      required: "City is required",
                                      validate: validateNoBlankSpaces,
                                    })}
                                  />
                                  {errors.City && (
                                    <div className="error">
                                      {errors.City.message}
                                    </div>
                                  )}
                                  <div className="row">
                                    <div className=" col-md-6 col-12">
                                      <input
                                        disabled={!editStatus}
                                        type="text"
                                        className="form-control mb-2 "
                                        placeholder="Country"
                                        {...register(
                                          "Country"
                                          // , {
                                          //   required: "Country is required",
                                          // }
                                        )}
                                      />
                                      {errors.Country && (
                                        <div className="error">
                                          {errors.Country.message}
                                        </div>
                                      )}
                                    </div>
                                    <div className="mb-4 col-md-6 col-12">
                                      <input
                                        disabled={!editStatus}
                                        type="text"
                                        className="form-control mb-2 "
                                        placeholder="Pin code"
                                        {...register(
                                          "Pincode"
                                          // , {
                                          //   required: "Pin code is required",
                                          // }
                                        )}
                                      />
                                      {errors.Pincode && (
                                        <div className="error">
                                          {errors.Pincode.message}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>

                                {/* form group */}
                                <div className="mb-4 col-md-5 col-12">
                                  <label className="form-label">
                                    Logo{" "}
                                    {/* <span className="text-danger">*</span> */}
                                  </label>
                                  <div className="d-flex justify-content-center align-items-center dropzone border-dashed min-h-0 rounded-2 dz-clickable">
                                    <div className="dz-default dz-message">
                                      <div className="dz-button" type="button">
                                        {!logoImage && (
                                          <div
                                            onClick={() =>
                                              imageRef.current.click()
                                            }
                                          >
                                            {" "}
                                            Upload Logo
                                          </div>
                                        )}

                                        {logoImage && (
                                          <div className="image-wrapper">
                                            <img
                                              src={logoImage}
                                              alt="Preview"
                                              style={{ width: "150px" }}
                                              onClick={() =>
                                                imageRef.current.click()
                                              }
                                            />
                                            {editStatus && (
                                              <div
                                                className="remove-img"
                                                onClick={() => removeImage()}
                                              >
                                                <IoIosCloseCircle size={20} />
                                              </div>
                                            )}
                                          </div>
                                        )}
                                      </div>
                                      <input
                                        disabled={!editStatus}
                                        type="file"
                                        ref={imageRef}
                                        accept="image/*"
                                        onChange={handleImageChange}
                                        className="d-none"
                                      />
                                    </div>
                                  </div>
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-7 col-12">
                                  <label className="form-label">
                                    Website Url{" "}
                                    {/* <span className="text-danger">*</span> */}
                                  </label>
                                  <input
                                    disabled={!editStatus}
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter website url"
                                    {...register("WebAddr", {
                                      pattern: {
                                        value:
                                          /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})(\.[a-zA-Z0-9]{2,})?/,
                                        message: "Invalid website url",
                                      },
                                    })}
                                  />
                                  {errors.WebAddr && (
                                    <div className="error">
                                      {errors.WebAddr.message}
                                    </div>
                                  )}
                                </div>
                                <div className="mb-4 col-md-12 col-12 d-flex align-items-end">
                                  <label
                                    className=" pe-3"
                                    htmlFor="flexSwitchStock"
                                  >
                                    <strong>Auto Notification</strong>
                                  </label>
                                  {console.log(watchField.AutoNotification)}
                                  <div className="form-check form-switch d-flex justify-content-center align-items-center ">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      id="flexSwitchStock"
                                      checked={watchField.AutoNotification}
                                      disabled={!editStatus}

                                      // onClick={(e) => handelStatusChange(e)}
                                      // disabled={isSubtaskDisabled()}
                                      {...register(
                                        "AutoNotification"


                                      )}

                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mt-4 mb-5 d-flex justify-content-between">
                            <div className="left d-flex">
                              {editStatus && (
                                <div
                                  className="  btn btn-outline-danger me-2"
                                  onClick={() => {
                                    setEditStatus(false);
                                    setIsCancel(true);
                                  }}
                                >
                                  Cancel
                                </div>
                              )}
                              <div className="  rounded-circl notification-count">
                                <div

                                  className="btn btn-dark me-2"
                                  onClick={() => handleExternalSubmit()}
                                >
                                  Attachments
                                </div>
                                <div className="notification-count d-flex justify-content-center">
                                  {attachmentCount}
                                </div>
                              </div>
                            </div>
                            <div className="right">
                              {!editStatus ? (
                                <div
                                  className="btn btn-primary"
                                  onClick={() => {
                                    setEditStatus(true);
                                    setIsCancel(false);
                                  }}
                                >
                                  Edit
                                </div>
                              ) : (
                                <button className="btn btn-primary">
                                  Save
                                </button>
                              )}
                            </div>
                          </div>
                        </form>
                      );
                    case "attachments":
                      return (
                        <Attachment
                          setTab={setTab}
                          setAttachmentCount={setAttachmentCount}
                          setTitle={setTitle}
                          attachmentType={"company"}
                          TranType={1}
                          AttchType={1}
                        >
                        </Attachment>
                      );
                    // case "notifications":
                    //   return <></>;
                    // case "attachments":
                    //   return <Attachments />;
                    // case "notifications":
                    //   return <Notifications />;
                    default:
                      return <div>No content available for this tab.</div>;
                  }
                })()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyInfo;
